<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
    >
      <v-list>
        <template v-for="navSection in navSections">
          <v-subheader :key="navSection.section">{{ navSection.section }}</v-subheader>
          <v-list-tile
            v-for="(item, index) in navSection.links"
            :key="`${navSection.section}-${index}`"
            :to="item.to"
            :href="item.href"
            :target="item.target"
            class="pl-4"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="white"
      height="55px"
      scroll-off-screen
      class="google-font"
    >
      <v-btn icon class="hidden-md-and-up mr-2" @click="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-btn>
      <a class="nav-logo-wrapper py-3" href="/">
        <img
          :src="require('@bugseq-site/shared/src/assets/img/nav-logo.png')"
          class="nav-logo"
        />
      </a>
      <v-toolbar-items class="ml-2 hidden-md-and-down">
      <v-menu
        open-on-hover
        offset-y
        v-for="navSection in navSections"
        :key="navSection.section"
      >
        <template v-slot:activator="{ on }">
          <v-layout v-on="on">
            <v-btn
              class="ml-0 text-capitalize"
              flat
              :to="navSection.to"
              active-class=""
            >
              {{navSection.section}}
            </v-btn>
          </v-layout>
        </template>

        <v-list>
          <v-list-tile
            v-for="(item, index) in navSection.links"
            :key="index"
            :to="item.to"
            :href="item.href"
            :target="item.target"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-layout>
        <v-btn
          class="text-capitalize"
          flat
          :to="{ name: 'quote' }"
        >
          Request Quote
        </v-btn>
        <v-btn
          class="text-capitalize mr-2 hidden-sm-and-down"
          flat
          :to="{ name: 'bookdemo' }"
        >
          Book a Demo
        </v-btn>
        <v-btn
          class="elevation-1 text-capitalize"
          color="primary"
          :href="loginUrl"
        >
          Login
        </v-btn>
      </v-layout>
    </v-toolbar-items>
  </v-toolbar>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import { getAppUrl } from "@bugseq-site/shared/src/env"

@Component
export default class Toolbar extends Vue {
  private drawer = false
  private navSections = [
    {
      section: "About",
      to: { name: "home" },
      links: [
        {
          title: "The BugSeq Advantage",
          to: { name: "home", hash: "#whybugseq" },
        },
        {
          title: "How It Works",
          to: { name: "home", hash: "#about" },
        },
        {
          title: "Contact Us",
          to: { name: "home", hash: "#contact" },
        },
        {
          title: "Pricing",
          to: { name: "pricing" },
        },
      ],
    },
    {
      section: "Applications",
      to: { name: "applications" },
      links: [
        {
          title: "Metagenomics",
          to: { name: "applications", hash: "#metagenomics" },
        },
        {
          title: "Hospital Acquired Infections",
          to: { name: "applications", hash: "#hai" },
        },
        {
          title: "16S/ITS",
          to: { name: "applications", hash: "#sixteens" },
        },
        {
          title: "Viral Analysis",
          to: { name: "applications", hash: "#viral" },
        },
        {
          title: "Pathogen Pipelines",
          to: { name: "pathogen-pipelines" },
        },
      ],
    },
    {
      section: "Data Analysis",
      to: { name: "analysis" },
      links: [
        {
          title: "Taxonomic Classification",
          to: { name: "analysis", hash: "#taxonomic-classification" },
        },
        {
          title: "Curated Database",
          to: { name: "analysis", hash: "#databases" },
        },
        {
          title: "Antimicrobial Resistance",
          to: { name: "analysis", hash: "#amr" },
        },
        {
          title: "Outbreak Analysis",
          to: { name: "analysis", hash: "#outbreak-analysis" },
        },
        {
          title: "Plasmid Detection",
          to: { name: "analysis", hash: "#plasmid-detection" },
        },
        {
          title: "Quality Control",
          to: { name: "analysis", hash: "#quality-control" },
        },
        {
          title: "Subtyping",
          to: { name: "analysis", hash: "#subtyping" },
        },
        {
          title: "Pathogen Identification",
          to: { name: "analysis", hash: "#pathogen-identification" },
        },
      ],
    },
    {
      section: "Resources",
      links: [
        {
          title: "Publications",
          to: { name: "publications" },
        },
        {
          title: "Documentation",
          href: "https://docs.bugseq.com",
          target: "_blank",
        },
        {
          title: "Blog",
          href: "https://docs.bugseq.com/blog",
          target: "_blank",
        },
        {
          title: "Conferences",
          to: { name: "conferences" },
        },
        {
          title: "Webinars",
          to: { name: "webinars" },
        },
        {
          title: "Support",
          to: { name: "support" },
        },
      ],
    },
  ]
  private loginUrl = `${getAppUrl()}/login`
}
</script>

<style>
.nav-logo-wrapper {
  height: 100%;
}

.nav-logo {
  height: 100%;
}
</style>
